import { getKindDefault } from "~/common/defaults/kind.default";
import type { PricePolicyAdapted } from "~/common/interfaces/entities/price-policy.interface";

export const getPricePolicyDefault = (): PricePolicyAdapted => ({
	id: 0,
	price: 0,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	kind: getKindDefault(),
	materials: [],
	sizes: []
});
